import React from 'react';

// import styles from "../../global.scss";
import "./styles.scss";

const AboutPage = () => {
  return (
		<div dangerouslySetInnerHTML={{ __html: `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>About Us | LusidPay</title>
  <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;800&display=swap" rel="stylesheet">
  <style>
    :root {
      --blue-main: #253f83;
      --blue-btn-hover: #0d67e3;
      --blue-dark: #004182;
      --blue-muted: #56687a;
      --blue-light: #dce6f1;
      --grey-main: #38434f;
      --grey-light: #e9e5df;
      --off-white: #fdfaf5;
      --white: #ffffff;
      --accent-green: #00c49a;
    }
    html, body {
      margin: 0;
      padding: 0;
      background: var(--white);
      color: var(--grey-main);
      font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
      // font-size: 18px;
      line-height: 1.6;
    }
    header {
      width: 100%;
      background: var(--white);
      position: sticky;
      top: 0;
      z-index: 100;
      border-bottom: 1px solid var(--grey-light);
    }
    .nav-container {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 32px;
    }
    .logo img {
      height: 40px;
      display: block;
    }
    nav {
      display: flex;
      gap: 32px;
      align-items: center;
    }
    nav a {
      text-decoration: none;
      color: var(--grey-main);
      font-weight: 500;
      font-size: 1rem;
      padding: 6px 0;
      transition: color 0.15s;
    }
    nav a:hover {
      color: var(--blue-main);
    }
    .cta-nav {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 20px;
      padding: 8px 22px;
      font-weight: 600;
      font-size: 1rem;
      margin-left: 12px;
      text-decoration: none;
      transition: background 0.15s;
      border: none;
      cursor: pointer;
    }
    .cta-nav:hover {
      background: var(--blue-btn-hover);
    }
    .hero {
      background: var(--white);
      text-align: center;
      padding: 90px 20px 40px 20px;
      margin-bottom: 20px;
    }
    .hero h1 {
      font-size: 2.8rem;
      font-weight: 800;
      color: black;
      margin-bottom: 18px;
      letter-spacing: -1px;
    }
    .hero p {
      font-size: 1.25rem;
      color: var(--grey-main);
      margin-bottom: 0;
      max-width: 650px;
      margin-left: auto;
      margin-right: auto;
    }
    .section {
      max-width: 1100px;
      margin: 0 auto 60px auto;
      padding: 0 24px;
    }
    .section-title {
      font-size: 2rem;
      font-weight: 700;
      color: var(--blue-main);
      text-align: center;
      margin-bottom: 30px;
      letter-spacing: -0.5px;
    }
    .about-block {
      background: var(--blue-light);
      border-radius: 18px;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
      padding: 36px 28px;
      margin-bottom: 36px;
      max-width: 900px;
      margin-left: auto;
      margin-right: auto;
    }
    .about-block h2, .about-block h3 {
      color: var(--blue-main);
      margin-top: 0;
      font-weight: 700;
      margin-bottom: 12px;
      font-size: 1.3em;
    }
    .about-block p {
      margin-bottom: 16px;
      color: var(--grey-main);
      font-size: 1.08em;
    }
    .about-list-row {
      display: flex;
      gap: 28px;
      justify-content: center;
      flex-wrap: wrap;
      margin-bottom: 36px;
    }
    .about-list-block {
      background: var(--white);
      border-radius: 16px;
      box-shadow: 0 2px 8px rgba(10,102,194,0.04);
      padding: 28px 22px;
      min-width: 220px;
      max-width: 320px;
      flex: 1 1 220px;
      text-align: center;
      color: var(--blue-dark);
      font-size: 1.07em;
      font-weight: 600;
    }
    .about-list-block span {
      display: block;
      font-size: 2em;
      margin-bottom: 8px;
    }
    .about-team-block {
      background: var(--blue-light);
      border-radius: 16px;
      box-shadow: 0 2px 8px rgba(10,102,194,0.04);
      padding: 36px 28px;
      max-width: 900px;
      margin: 0 auto 36px auto;
      text-align: center;
    }
    .about-team-block h3 {
      color: var(--blue-main);
      margin-bottom: 12px;
      font-size: 1.2em;
      font-weight: 700;
    }
    .about-team-block p {
      color: var(--grey-main);
      font-size: 1.08em;
      margin-bottom: 0;
    }
    .about-journey {
      background: var(--white);
      border-radius: 16px;
      box-shadow: 0 2px 8px rgba(10,102,194,0.04);
      padding: 36px 28px;
      max-width: 900px;
      margin: 0 auto 36px auto;
      text-align: center;
    }
    .about-journey h3 {
      color: var(--blue-main);
      margin-bottom: 12px;
      font-size: 1.2em;
      font-weight: 700;
    }
    .about-journey p {
      color: var(--grey-main);
      font-size: 1.08em;
      margin-bottom: 0;
    }
    .about-conclusion {
      text-align: center;
      max-width: 800px;
      margin: 0 auto 40px auto;
      color: var(--blue-dark);
      font-size: 1.13em;
      font-weight: 600;
    }
    .cta-section {
      background: var(--white);
      text-align: center;
      padding: 70px 0 70px 0;
    }
    .cta-section h2 {
      color: var(--blue-main);
      font-size: 2rem;
      margin-bottom: 18px;
      font-weight: 700;
    }
    .cta-section .cta-main {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 10px;
      padding: 16px 46px;
      font-size: 1.1rem;
      font-weight: 700;
      border: none;
      cursor: pointer;
      margin: 0 10px;
      transition: background 0.15s;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
    }
    .cta-section .cta-main:hover {
      background: var(--blue-btn-hover);
    }
    footer {
      background: var(--off-white);
      padding: 40px 0;
      text-align: center;
      font-size: 1rem;
      color: var(--blue-muted);
      border-top: 1px solid var(--blue-light);
      letter-spacing: 0.1px;
    }
    @media (max-width: 1000px) {
      .about-list-row { flex-direction: column; align-items: center; }
      .section { padding: 0 8px; }
    }
  </style>
</head>
<body>

  <section class="hero">
    <h1>About LusidPay</h1>
    <p>
      Modern fintech, made lucid.<br>
      Discover our story, mission, and the passionate team behind LusidPay.
    </p>
  </section>

  <section class="section">
    <div class="about-block">
      <h2>Story Behind the Name LusidPay</h2>
      <p>
        When brainstorming names for our company, we wanted something that would reflect our core values and the essence of what we aim to achieve in the fintech industry. We chose the name <strong>LusidPay</strong> as a play on the word <em>lucid</em>, meaning "expressed clearly or easy to understand."
      </p>
      <p>
        LusidPay also has a modern and distinctive sound, aligning with our vision of being a forward-thinking, cutting-edge fintech company. We strive to bring a fresh perspective to the industry by combining technology, data, frictionless interfaces, and automation.
      </p>
    </div>

    <div class="about-block">
      <h2>Who We Are</h2>
      <p>
        LusidPay takes pride in being a dynamic and innovative fintech company. With a team of passionate experts, we are fully equipped to serve our loyal customers. Our journey began with a simple vision: to deliver exceptional products and services that surpass expectations and leave a lasting impression.
      </p>
    </div>

    <div class="about-block">
      <h2>Our Mission</h2>
      <p>
        At LusidPay, our mission is to revolutionize the adoption of technology by small businesses. We strive to be pioneers, setting new standards and challenging the status quo. We believe in fostering long-lasting relationships with our customers and partners, built on trust, transparency, and the delivery of exceptional results.
      </p>
    </div>

    <div class="section-title" style="margin-top:60px;">What Sets Us Apart</div>
    <div class="about-list-row">
      <div class="about-list-block">
        <span>🎓</span>
        <strong>Expertise</strong><br>
        Our team comprises highly skilled professionals who are experts in AI, Technology and Accounting.
      </div>
      <div class="about-list-block">
        <span>💡</span>
        <strong>Innovation</strong><br>
        Our relentless pursuit of improvement and staying ahead of the curve enables us to deliver cutting-edge solutions.
      </div>
      <div class="about-list-block">
        <span>🤝</span>
        <strong>Customer Focus</strong><br>
        Our clients are of utmost importance to us. We believe in cultivating strong, mutually beneficial relationships.
      </div>
      <div class="about-list-block">
        <span>🛠️</span>
        <strong>Flexibility</strong><br>
        We recognize that one size does not fit all. Hence, we offer flexible and customizable solutions just for you.
      </div>
    </div>

    <div class="about-team-block">
      <h3>Our Team</h3>
      <p>
        Behind every successful company lies an exceptional team. At LusidPay, we foster a collaborative and inclusive environment, encouraging creativity and innovation at every step. Our people are the backbone of our organization.
      </p>
    </div>

    <div class="about-journey">
      <h3>Join Us on Our Journey</h3>
      <p>
        We believe that success is a journey, not a destination. We are constantly evolving, adapting, and embracing change. Together with our clients, we aim to create a brighter and better future.<br><br>
        Whether you seek a partnership, new opportunities, or simply wish to learn more about our endeavors, we are here for you. Reach out to our friendly team today and let us embark on this exciting journey together!
      </p>
    </div>

    <div class="about-conclusion">
      <p>
        We sincerely appreciate your time in getting to know LusidPay better. We hope this glimpse into our world has piqued your interest and shed light on what sets us apart.<br>
        <br>
        <strong>Remember, we are not just another company; we are a team of passionate individuals committed to making a difference. Stay tuned for more exciting updates — the journey with LusidPay has only just begun!</strong>
      </p>
    </div>
  </section>

  <section class="cta-section" id="about-cta">
    <h2>Want to join us or partner with LusidPay?</h2>
    <button class="cta-main" onclick="window.location='mailto:contact@lusidpay.com'">Contact Our Team</button>
  </section>

</body>
</html>
` }} />
  )
}

export default AboutPage;